export default "__VITE_ASSET__2de6cf2e__"